import { getDatadogBrowserHostname } from '@/monitoring/datadogBrowser'
import { getSellerPropsForLogs } from '@/monitoring/logger'
import { isProductionEnvironment } from '@/resources/utils/global/environment'
import { generateTraceId } from '@/trace'
import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

const SITE = 'datadoghq.com'

const hasDatadogCredentials = Boolean(
  process.env.DATADOG_APP_ID && process.env.DATADOG_CLIENT_TOKEN
)

const isBrowserRunningOnLocalhost = (): boolean => {
  const hostname = getDatadogBrowserHostname()
  return hostname === 'localhost' || hostname === '127.0.0.1'
}

export const isDatadogEnabled =
  hasDatadogCredentials &&
  isProductionEnvironment &&
  !isBrowserRunningOnLocalhost()

const datadogEnvFromBuild =
  typeof process.env.DATADOG_ENV === 'string' && process.env.DATADOG_ENV !== ''
    ? process.env.DATADOG_ENV
    : undefined

export const initDatadog = () => {
  if (!isDatadogEnabled) {
    return
  }

  const environment =
    datadogEnvFromBuild ?? (isProductionEnvironment ? 'prod' : 'dev')

  datadogRum.init({
    applicationId: process.env.DATADOG_APP_ID ?? '',
    clientToken: process.env.DATADOG_CLIENT_TOKEN ?? '',
    site: SITE,
    service: process.env.DATADOG_SERVICE,
    env: environment,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
    trackResources: true,
  })

  datadogRum.startSessionReplayRecording()

  datadogLogs.init({
    clientToken: process.env.DATADOG_CLIENT_TOKEN ?? '',
    site: SITE,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    service: process.env.DATADOG_SERVICE,
    env: environment,
    beforeSend: log => {
      log.seller = getSellerPropsForLogs()
      log.trace_id = generateTraceId()
      return true
    },
  })
}

export const updateDatadogUser = () => {
  if (!isDatadogEnabled) {
    return
  }

  const sellerData = getSellerPropsForLogs()
  const rawId = sellerData.poc_id
  const id =
    rawId != null && typeof rawId !== 'object' ? String(rawId) : 'no_data'
  datadogRum.setUser({ id })
}

export const clearDatadogUser = () => {
  if (!isDatadogEnabled) {
    return
  }

  datadogRum.setUser({ id: 'no_data' })
}
